import { Link } from "react-router-dom";
import { Play, Eye } from "lucide-react";
import { resolveMedia } from "@/lib/api";

const CATEGORY_LABEL = {
  "leaked-sextape": "Leaked Sextape",
  "sleeping-sex": "Sleeping Sex",
  "animation-xvideos": "Animation xvideos",
  "cctv-hidden": "CCTV Hidden",
  "african-leaked": "African Leaked",
};

const formatViews = (n) => {
  if (!n) return "0";
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + "M";
  if (n >= 1_000) return (n / 1_000).toFixed(1) + "K";
  return String(n);
};

export const VideoCard = ({ video, featured = false }) => {
  return (
    <Link
      to={`/video/${video.id}`}
      data-testid={`video-card-${video.id}`}
      className="group block"
    >
      <div className="relative overflow-hidden rounded-sm bg-[#0f0f0f]">
        <div className="aspect-video w-full overflow-hidden">
          <img
            src={resolveMedia(video.thumbnail_url)}
            alt={video.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
        </div>
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/70 via-black/0 to-black/0 opacity-80 transition-opacity duration-500 group-hover:opacity-100" />
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-500 group-hover:opacity-100">
          <div className="flex h-16 w-16 items-center justify-center rounded-full border border-white/40 bg-black/30 backdrop-blur-md">
            <Play className="h-6 w-6 translate-x-[2px] text-white" fill="white" />
          </div>
        </div>
        <div className="absolute left-3 top-3">
          <span className="rounded-sm bg-black/60 px-2 py-1 text-[10px] uppercase tracking-[0.2em] text-[#f2f2f2] backdrop-blur">
            {CATEGORY_LABEL[video.category] || video.category}
          </span>
        </div>
      </div>
      <div className={`mt-3 ${featured ? "" : ""}`}>
        <h3
          className={`font-display tracking-tight text-[#f2f2f2] transition-colors group-hover:text-[#e60039] ${
            featured ? "text-xl md:text-2xl" : "text-lg"
          }`}
        >
          {video.title}
        </h3>
        <div className="mt-1 flex items-center gap-3 text-sm text-[#a3a3a3]">
          <span className="inline-flex items-center gap-1">
            <Eye className="h-3.5 w-3.5" />
            {formatViews(video.views)} views
          </span>
        </div>
      </div>
    </Link>
  );
};

export default VideoCard;
